import { Fragment, useEffect, useState } from "react";
import { useNotify } from "react-admin";
import { handleAxiosError } from "../../common/data/axiosErrorHandler";
import {
  DashboardApiFactory,
  DashboardDriverHosEventsOutput,
} from "../../common/data/service-proxies";
import { useAppData } from "../../common/hooks/useAppData";
import { useAxiosInstance } from "../../common/hooks/useAxiosInstance";
import { DashboardHosGraph } from "./DashboardHosGraph";

interface Props {
  position?: number;
  date: Date;
  vehicleId: number;
}

export const DashboardVehicleHosGraph = ({
  position,
  vehicleId,
  date,
}: Props) => {
  const axios = useAxiosInstance();
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<DashboardDriverHosEventsOutput[]>();
  const notify = useNotify();
  const timeZoneInfo = useAppData((x) => x.timeZoneInfo);

  useEffect(() => {
    if (!axios) {
      return;
    }

    setLoading(true);
    DashboardApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppDashboardDashboarddriverhoseventsGet(vehicleId, date.toISOString())
      .then((response) => {
        setData(response.data);
      })
      .catch((e) => {
        const error = handleAxiosError(e);
        notify(error, { type: "error" });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [axios, date, notify, vehicleId, timeZoneInfo]);

  return !loading && !!data ? (
    <>
      {data.map((x) => (
        <Fragment key={x.driverId}>
          <DashboardHosGraph hosEvents={x} date={date} position={position} />
        </Fragment>
      ))}
    </>
  ) : null;
};
